module.exports = __webpack_public_path__ + "static/media/1.111a99c1.png";